export const MENU_PANEL_WIDTH = 320;
